<template>
  <div>
    <v-dialog v-model="showDeleteConfirmationDialog" max-width="550px">
      <v-card>
        <v-card-title>
          <h3>Are you sure you want to delete show result?</h3>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="showDeleteConfirmationDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="primary" @click="confirmDelete"> Delete </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert width="100%" v-if="infoMessage" type="info" dismissible>
      {{ infoMessage }}
    </v-alert>
    <v-alert width="100%" v-if="errorMessage" type="error" dismissible>
      {{ errorMessage }}
    </v-alert>
    <table class="pl-5 pr-7">
      <tr>
        <th>Date</th>
        <th>Class</th>
        <th># Cmp</th>
        <th>Place</th>
        <th>JSH</th>
        <th>Score</th>
        <th></th>
        <!-- actions column -->
      </tr>
      <tr :id="`#sr-empty`" v-if="!!emptyRow" class="orange lighten-4">
        <td class="">
          <DatepickerFormatted
            :disableClearable="true"
            :date="emptyRow.showDate"
            v-on:updateDates="
              ($event) => updateDates($event, 'showDate', emptyRow)
            "
          />
        </td>
        <td class="pr-1 pl-1">
          <v-autocomplete
            v-model="emptyRow.classId"
            item-value="id"
            item-text="description"
            :items="classes"
            :rules="[(v) => !!v || 'Required']"
          />
        </td>
        <td class="pr-1 pl-1">
          <v-text-field
            v-model="emptyRow.numberCompeting"
            type="numeric"
            :rules="[(v) => !isNaN(v) || 'Numeric value required']"
          />
        </td>
        <td class="pr-1 pl-1">
          <v-text-field
            v-model="emptyRow.place"
            type="numeric"
            :rules="[(v) => !isNaN(v) || 'Numeric value required']"
          />
        </td>
        <td class="pr-1 pl-1">
          <v-simple-checkbox v-model="emptyRow.isBJH" v-ripple />
        </td>
        <td class="pr-1 pl-1">
          <v-text-field
            v-model="emptyRow.points"
            type="numeric"
            :rules="[(v) => !isNaN(v) || 'Numeric value required']"
          />
        </td>
        <td class="pl-1" style="width: 60px">
          <v-icon
            class="mr-1"
            color="primary"
            @click="saveShowResult(emptyRow)"
          >
            mdi-content-save-edit
          </v-icon>
        </td>
      </tr>
    </table>
    <v-divider inset />
    <v-divider inset />
    <v-virtual-scroll
      :items="showResults"
      :item-height="75"
      height="680"
      content-tag="table"
      id="JuniorTitledDogsVirtualScroller"
    >
      <template v-slot:default="{ item, index }">
        <v-list-item key="item.id" :id="`sr-${item.id}`">
          <v-list-item-content>
            <tr :class="row_classes(item, index)" :id="item.id">
              <td class="pr-1 pl-1">
                <DatepickerFormatted
                  :disableClearable="true"
                  :date="item.showDate"
                  v-on:updateDates="
                    ($event) => updateDates($event, 'showDate', item)
                  "
                />
              </td>
              <td class="pr-1 pl-1">
                <v-autocomplete
                  v-model="item.classId"
                  item-value="id"
                  item-text="description"
                  :items="classes"
                  :rules="[(v) => !!v || 'Required']"
                />
              </td>
              <td class="pr-1 pl-1">
                <v-text-field
                  v-model="item.numberCompeting"
                  type="numeric"
                  :rules="[(v) => !isNaN(v) || 'Numeric value required']"
                />
              </td>
              <td class="pr-1 pl-1">
                <v-text-field
                  v-model="item.place"
                  type="numeric"
                  :rules="[(v) => !isNaN(v) || 'Numeric value required']"
                />
              </td>
              <td class="pr-1 pl-1">
                <v-simple-checkbox v-model="item.isBJH" v-ripple />
              </td>
              <td class="pr-1 pl-1">
                <v-text-field
                  v-model="item.points"
                  type="numeric"
                  :rules="[(v) => !isNaN(v) || 'Numeric value required']"
                />
              </td>
              <td class="pl-1" style="width: 60px">
                <v-icon
                  class="mr-1"
                  color="primary"
                  @click="saveShowResult(item)"
                >
                  mdi-content-save-edit
                </v-icon>
                <v-icon
                  :disabled="!item.id"
                  tabindex="-1"
                  @click="deleteShowResult(item)"
                >
                  mdi-delete
                </v-icon>
              </td>
            </tr>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-virtual-scroll>
    <v-divider class="my-3"></v-divider>
    <JuniorTotalPoint :personId="personId" :scoreType="scoreType" :classes="classes" />
    <JuniorTotalPoint :personId="personId" :scoreType="scoreType" :classes="classes" :fromPreviousDate="true" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import * as _ from "lodash";
import DatepickerFormatted from "@/components/common/inputs/DatepickerFormatted.vue";
import JuniorTotalPoint from "@/components/common/JuniorTotalPoint.vue";
import juniorHandlerService from "@/services/admin/juniorHandlerService";
import { JrHandlerScoreType } from "@/types/admin/JuniorHandler";

export default Vue.extend({
  name: "JuniorObedienceScores",
  props: {
    personId: { type: Number },
    classes: { type: [] as any[] },
  },
  components: {
    DatepickerFormatted,
    JuniorTotalPoint,
  },
  data: function () {
    return {
      scoreType: JrHandlerScoreType.Obedience,
      showResults: [] as any[],
      persistedShowResults: [] as any[],
      juniorHandlingScoresInfo: {} as any,
      emptyRow: {} as any,
      deletedItem: null as any,
      errorMessage: null as any,
      infoMessage: null as any,
      showDeleteConfirmationDialog: false,
    };
  },
  created: function () {
    if (this.personId) {
      this.reloadData();
    }
  },
  watch: {
    personId: function (newVal: String) {
      this.reloadData();
    },
  },
  methods: {
    emptyShowResultRow: function () {
      return {
        id: null,
        showDate: null,
        classId: null,
        numberCompeting: null,
        place: null,
        isBJH: null,
        points: null,
        juniorPersonId: this.personId,
      };
    },
    reloadData: function () {
      juniorHandlerService
        .getJuniorHandlingResultsByJuniorPersonId(
          this.personId,
          JrHandlerScoreType.Obedience
        )
        .then((res) => {
          this.juniorHandlingScoresInfo = res;
          this.showResults = res.scores;
          this.persistedShowResults = res.scores;
          this.emptyRow = this.emptyShowResultRow();
        });
    },
    updateDates: function (val: any, key: string, item: any) {
      item[key] = val?.date;
      //workaround to force rerendering after setting up formatted date
      this.$set(this, "showResults", this.showResults);
    },
    saveShowResult: function (item: any) {
      this.$store.dispatch("changeLoaderStatus", true);
      const isAddingNewRow = !item.id;

      juniorHandlerService
        .updateObedienceScoreEntry(item)
        .then((res: any) => {
          if (!res.success) {
            this.errorMessage = res.messages.join(", ");
            if (isAddingNewRow) {
              const input = document.querySelector(
                "#srEmptyDogId"
              ) as HTMLElement | null;

              if (input != null) {
                input.focus();
              }
            }
          } else {
            if (isAddingNewRow) {
              this.emptyRow.id = res.id;
              this.showResults.unshift(this.emptyRow);
              this.persistedShowResults = _.cloneDeep(this.showResults);

              this.emptyRow = Object.assign({}, this.emptyShowResultRow());
              this.$set(this, "emptyRow", this.emptyRow);

              const input = document.querySelector(
                "#srEmptyDogId"
              ) as HTMLElement | null;

              if (input != null) {
                input.focus();
              }
            } else {
              this.persistedShowResults = _.cloneDeep(this.showResults);
            }
            this.errorMessage = null;
          }
        })
        .catch((e) => {
          this.errorMessage =
            "Changes couldn't be saved. Ensure there are no validation errors before retrying.";
        })
        .finally(() => {
          this.$store.dispatch("changeLoaderStatus", false);
        });
    },
    row_classes: function (item: any, index: number) {
      if (!!item.id) {
        const index = this.showResults.findIndex((i) => i.id === item.id);
        if (
          _.isEqual(this.showResults[index], this.persistedShowResults[index])
        ) {
          return "";
        }
      }
      return "orange  lighten-4";
    },
    deleteShowResult: function (item: any) {
      if (item.id) {
        //if that item has been persisted already
        this.deletedItem = item;
        this.showDeleteConfirmationDialog = true;
      }
    },
    confirmDelete: function () {
      if (this.deletedItem == null) {
        return;
      }
      juniorHandlerService
        .deleteHandlingScoreEntry(this.deletedItem.id)
        .then((res: any) => {
          if (!res.success) {
            this.errorMessage = res.messages.join(", ");
          } else {
            this.deletedItem = null;
            this.reloadData();
          }
        })
        .finally(() => {
          this.showDeleteConfirmationDialog = false;
        });
    },
  },
});
</script>